import * as enm from "lib/enum";

const permissionType = enm.DefineEnum(["Admin", "Read-Only"] as const);

export type PermissionType = enm.VariantOf<typeof permissionType>;

export const { Admin, "Read-Only": ReadOnly } = permissionType;
